import React from 'react';
import { useTranslation } from 'react-i18next';
import { useShowSidebar } from 'Core/hooks/useShowSidebar';
import Header from 'Core/components/Header';
import Main from 'Core/components/Main';
import { GlobalPageAlert } from 'Core/components/Alert';
import HeaderBanner from 'Core/components/HeaderBanner';
import FooterBanner from 'Core/components/FooterBanner';
import StickyFooter from 'Core/components/StickyFooter';
import Loader from 'Core/components/Loader';
import { useSearch } from 'react-location';


const Page = ({
  children,
  title,
  subtitle,
  stepProgressProps = {},
  withStepProgress = true,
  withSidebar = false,
  withCardPrefCenterLink = false,
  stickyFooter = false,
  branding = '',
  hideAlert = false,
}) => {
  const { t } = useTranslation();
  const shouldShowSidebar = useShowSidebar();
  const fallback = <Loader message={t('status.loading.component')} />;
  const { embed: isEmbedded = false } = useSearch();

  if (withSidebar && shouldShowSidebar) {
    return (
      <React.Suspense fallback={fallback}>
        <div className="flex flex-col min-h-screen">
          {!isEmbedded && <HeaderBanner />}
          <Header
            title={title}
            withCardPrefCenterLink={withCardPrefCenterLink}
            branding={branding || ''}
          />
          <Main className="flex-grow">
            <div className="grid gap-4 [grid-template-columns:1fr_min-content]">
              <div className="grow-[2]">
                {!hideAlert && <GlobalPageAlert />}
                {children}
              </div>

            </div>
          </Main>
          {!isEmbedded && <FooterBanner />}
        </div>
      </React.Suspense>
    );
  }

  return (
    <div className="flex flex-col min-h-screen">
      {!isEmbedded && <HeaderBanner />}
      <Header
        title={title}
        subtitle={subtitle}
        withCardPrefCenterLink={withCardPrefCenterLink}
        branding={branding}
      />
      <Main className="flex-grow">
        {!hideAlert && <GlobalPageAlert />}
        {children}
      </Main>
      {!isEmbedded && stickyFooter ? <StickyFooter /> : <FooterBanner />}
    </div>
  );
};

export default Page;
